module.exports = __webpack_public_path__ + "static/media/15.5f0253fc.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/15.JPG
// module id = 457
// module chunks = 0